import React from "react";
import { motion } from "framer-motion";

export default function ProcessingAnimation({ imageSrc }) {
  return (
    <div className="relative flex flex-col items-center gap-8 py-8" data-testid="processing-animation">
      <div className="relative w-48 h-48 md:w-64 md:h-64">
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Analyzing"
            className="absolute inset-0 w-full h-full object-cover grayscale-[20%]"
          />
        )}
        <div className="absolute inset-0 pointer-events-none">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="absolute inset-0 border border-forest-600/70"
              animate={{ scale: [0.9, 1.4], opacity: [0.7, 0] }}
              transition={{
                duration: 2.4,
                repeat: Infinity,
                delay: i * 0.6,
                ease: "easeOut",
              }}
            />
          ))}
        </div>
        <motion.div
          className="absolute left-0 right-0 h-[2px] bg-forest-600/80 shadow-[0_0_12px_#1C352D]"
          animate={{ top: ["0%", "100%", "0%"] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <div className="text-center max-w-sm">
        <div className="overline mb-3">AI Analysis In Progress</div>
        <div className="font-heading text-2xl text-forest-700 leading-tight">
          Designing your future smile
        </div>
        <div className="text-sm text-forest-400 mt-3 leading-relaxed">
          Our clinical model is studying your bite, jawline and lip line to
          render a photorealistic clear-aligner preview. This usually takes 20–40
          seconds.
        </div>
      </div>
    </div>
  );
}
